import {clsx} from 'clsx'
import {twMerge} from 'tailwind-merge'
import {FILE} from '@/utils/constants/commonConstants'

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export const isNotEmptyAndDefined = value => {
  return value !== undefined && value !== ''
}
export const isObjectNotEmpty = obj => {
  return Object.keys(obj).every(key => obj[key] !== null && obj[key] !== undefined && obj[key] !== '')
}
export const downloadCSVFiles = (csvString, fileName = 'File.csv') => {
  const blob = new Blob([csvString], {type: 'text/csv;charset=utf-8;'})

  const link = document.createElement('a')

  link.download = fileName

  link.href = URL.createObjectURL(blob)

  link.click()

  URL.revokeObjectURL(link.href)
}
export const getDateWithTimeString = () => {
  const date = new Date()
  const isoString = date.toISOString()
  const formattedDate = isoString
    .replace('T', '_')
    .replace(/\.\d{3}Z/, '')
    .replaceAll(':', '')
  return formattedDate
}

export const chooseByCondition = (condition,ifTrue,ifFalse) => {
  return condition ? ifTrue : ifFalse
}

export const convertImageToWebP = async (file, options = {}) => {
  const {quality = 0.9, entityType = null} = options
  const fileName = file?.name?.replace(/\.(png|jpe?g)$/i, '')

  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = event => {
      const img = new Image()
      img.onload = () => {
        const canvas = document.createElement('canvas')
        canvas.width = img.width
        canvas.height = img.height
        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0)

        canvas.toBlob(
          blob => {
            if (blob) {
              const webpFile = new File([blob], file?.type === 'image/webp' ? fileName : `${fileName}.webp`, {
                type: 'image/webp',
              })
              webpFile.error = file?.error ?? false

              resolve({
                webpFile,
                metadata: {
                  originalFileName: file?.name,
                  id: file?.type === 'image/webp' ? fileName?.split('.')[0] : fileName,
                  blobFormat: 'webp',
                  width: img.width,
                  height: img.height,
                  originalFormat: file?.type,
                  originalSize: file?.size,
                  blobFileSize: webpFile.size,
                  referenceEntity: entityType,
                },
                file: file,
              })
            } else {
              reject(new Error('Conversion to WebP failed'))
            }
          },
          'image/webp',
          quality
        )
      }
      img.onerror = () => reject(new Error('Image load failed'))
      img.src = event.target.result
    }
    reader.onerror = () => reject(new Error('File reading failed'))
    reader.readAsDataURL(file)
  })
}

/**
 * Validates filename for URL compatibility
 * @param {string} filename - The filename to validate
 * @returns {Object} - Object with isValid boolean and message string
 */
export const validateFilenameForUrl = filename => {
  if (!filename) return { isValid: false, message: 'Filename is required' }

  const lastDotIndex = filename.lastIndexOf('.')

  // If there's no dot, validate the entire filename for URL-safe characters
  if (lastDotIndex === -1) {
    // Check for characters that can cause URL issues (excluding spaces as they're handled by URL encoding)
    const urlUnsafeChars = /[<>:"/\\|?*]/
    if (urlUnsafeChars.test(filename)) {
      return {
        isValid: false,
        message: 'Special characters are not allowed. Please use only letters, numbers, hyphens (-), and underscores (_).'
      }
    }
    return { isValid: true, message: '' }
  }

  const filenameWithoutExt = filename.substring(0, lastDotIndex)
  const extension = filename.substring(lastDotIndex + 1).toLowerCase()

  // Derive allowed extensions from MIME types to stay consistent with existing image validation
  const allowedExtensions = FILE.ALLOWED_IMAGE_TYPES.map(mimeType => {
    const ext = mimeType.split('/')[1]
    return ext === 'jpeg' ? ['jpg', 'jpeg'] : [ext]
  }).flat()

  // If extension is not in allowed list, treat as invalid (dot in filename)
  if (!allowedExtensions.includes(extension)) {
    return {
      isValid: false,
      message: 'Dots (.) in filename are not supported. Please rename your file to remove dots from the filename.'
    }
  }

  // Check if filename contains dots (other than the extension dot)
  if (filenameWithoutExt.includes('.')) {
    return {
      isValid: false,
      message: 'Dots (.) in filename are not supported. Please rename your file to remove dots from the filename.'
    }
  }

  // Check for characters that can cause URL issues in the filename part (excluding spaces)
  const urlUnsafeChars = /[<>:"/\\|?*]/
  if (urlUnsafeChars.test(filenameWithoutExt)) {
    return {
      isValid: false,
      message: 'Special characters are not allowed. Please use only letters, numbers, hyphens (-), and underscores (_).'
    }
  }

  return { isValid: true, message: '' }
}
